import { Box, Grid, TextInput } from "@dehub/theme";
import { LockSimpleIcon } from "@phosphor-icons/react";
import type { UseFormReturnType } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import classes from "../../PartnerPage.module.css";
import { DefinitionList } from "../DefinitionList";
import type { IFormData } from "./org-form-model";

type Props = {
  form: UseFormReturnType<IFormData>;
  isEdit: boolean;
};

export function MainInfoContactSection({ form, isEdit }: Props) {
  const { t } = useTranslation("partner");
  const values = form.values;

  if (!isEdit) {
    return (
      <DefinitionList
        items={[
          { key: "phone", label: t("fields.phone1"), value: values.phone, locked: true },
          { key: "phone2", label: t("fields.phone2"), value: values.phone2 },
          { key: "email", label: t("fields.email1"), value: values.email, locked: true },
          { key: "email2", label: t("fields.email2"), value: values.email2 },
          { key: "web", label: t("fields.website"), value: values.web },
          { key: "fbLink", label: t("fields.facebook"), value: values.fbLink },
        ]}
      />
    );
  }

  return (
    <Box className={classes.editBody}>
      <Grid gap="sm">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            readOnly
            className={classes.locked}
            rightSection={<LockSimpleIcon className={classes.lockedIcon} size={16} weight="bold" role="img" aria-label={t("lockedHint")} />}
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            label={t("fields.phone1")}
            {...form.getInputProps("phone")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            label={t("fields.phone2")}
            placeholder="99112233"
            {...form.getInputProps("phone2")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            readOnly
            className={classes.locked}
            rightSection={<LockSimpleIcon className={classes.lockedIcon} size={16} weight="bold" role="img" aria-label={t("lockedHint")} />}
            type="email"
            autoComplete="email"
            spellCheck={false}
            label={t("fields.email1")}
            {...form.getInputProps("email")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            type="email"
            autoComplete="email"
            spellCheck={false}
            label={t("fields.email2")}
            placeholder="name@example.mn"
            {...form.getInputProps("email2")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            type="url"
            spellCheck={false}
            autoComplete="url"
            label={t("fields.website")}
            placeholder="https://example.mn"
            {...form.getInputProps("web")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            type="url"
            spellCheck={false}
            label={t("fields.facebook")}
            placeholder="https://facebook.com/example"
            {...form.getInputProps("fbLink")}
          />
        </Grid.Col>
      </Grid>
    </Box>
  );
}
